export const RICH_TEXT_MODULE_ID = "StaticText";
export const RICH_TEXT_MODULE_TRANSLATABLE_PROPERTIES_KEY = "StaticText";
export const RICH_TEXT_MODULE_NAMESPACE = "pagebuilder_Module";
